import React from 'react';
import { Card } from 'react-bootstrap';
import { useAuth } from '../../contexts/AuthContext';

const Dashboard = () => {
  const { user } = useAuth();

  return (
    <Card className="m-3">
      <Card.Header as="h5" style={{ backgroundColor: '#d1c4e9' }}>Dashboard</Card.Header>
      <Card.Body>
        <p>Mailing campaign management dashboard</p>
        <p>Welcome, {user?.username}!</p>
        {user?.isAdmin && <p><small className="text-muted">You have administrator privileges.</small></p>}
      </Card.Body>
    </Card>
  );
};

export default Dashboard;